import { render } from "./AppSwitch.vue?vue&type=template&id=1ffe49c5&scoped=true"
import script from "./AppSwitch.vue?vue&type=script&lang=js"
export * from "./AppSwitch.vue?vue&type=script&lang=js"

import "./AppSwitch.vue?vue&type=style&index=0&id=1ffe49c5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffe49c5"]])

export default __exports__